import { getFilterMetadata } from '../../../../components/StatelessComponent/FilterChainUtils';
import type { ListOption } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericShortListFilter/GenericShortListDropdown';
import type { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../../LabelFormatterType';

const DEFAULT_MAX_DISPLAYED_ITEMS = 3;

export const getValueLabel = <T>(
  currentValue: T[] | undefined,
  optionList: ListOption<T>[] | undefined,
  maxDisplayedItems = DEFAULT_MAX_DISPLAYED_ITEMS,
): string => {
  if (currentValue == null || optionList == null) {
    return '';
  }

  if (currentValue.length >= maxDisplayedItems) {
    return `(${currentValue.length})`;
  }

  const options = optionList.filter((option) => currentValue.includes(option.value));

  return options.reduce((output, option, index) => {
    let result = `${output}"${option.label}"`;
    if (index < options.length - 2) {
      result += ', ';
    } else if (index === options.length - 2) {
      result += ' or ';
    }
    return result;
  }, 'is ');
};

export const getLabels = <T>(
  currentValue: T[] | undefined,
  filterKind: FilterKindEnum,
  options: {
    optionList: ListOption<T>[] | undefined;
    maxDisplayedItems?: number;
  },
): LabelProps => {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue, options.optionList, options.maxDisplayedItems),
  };
};
